<!--html-->
<template src="../assets/html/problemDetail.html"></template>
<!--css引用-->
<style src="../assets/css/problemDetail.css" lang="css"></style>
<!--js脚本-->

<script>
  import C from "../utils/C";

  export default {
    name: 'ProblemDetail',
    data () {
      return {
        functionInfo:{},//选择的文章

        mafawu_back:"https://img.hatcloud.cn/20163316_1638536982755985707.png?e=2269256565&token=WsDlLjDgtDdmtdIV5Or9qEHGB6sODAC-O3wwCqF7:9dUbCFyqI1OzE8bUlQMdDrIj-_M=",
        isAndroid:false,
      }
    },
    mounted() {
      var getUrlParams = this.$C.getUri_params()

      var id = getUrlParams["id"]
      var that = this
      this.$netGo.getFunctionInfo(id).then(function (result) {
          // console.log(result);
          that.functionInfo = result.functionInfo
      })

      let systemParam = C.getSystemInfo();
      if (systemParam && systemParam.deviceType) {
        let deviceType = systemParam.deviceType;
        console.log("deviceType:"+deviceType)
        this.isAndroid = (deviceType == "android")
      }
    },
    methods:{
      close(event){
        //返回上一级
        window.history.back(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ProblemDetail.vue